import 'normalize.css';
import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import SlideUpDown from 'vue-slide-up-down';

Vue.component('slide-up-down', SlideUpDown)



Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

